export const TOP_5_COLORS = [
	'#9b59b6',
	'#3498db',
	'#2ecc71',
	'#f39c12',
	'#e74c3c',
]

export const TYPE_COLORS = [
	'#3498db',
	'#2ecc71',
	'#f1c40f',
	'#9b59b6',
	'#e74c3c',
	'#e67e22',
]

export const PRIORITY_COLORS_MAP = {
	Baixo: '#3498db',
	Média: '#f1c40f',
	Alta: '#e74c3c',
	Urgente: '#9b59b6',
	Baixa: '#3498db',
}
